import Typography from '@ben/orion/typography/typography';
import styled, { css } from 'styled-components';

export const FormContainer = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.palette.neutral[10]};
    border: 1px solid ${theme.palette.neutral[40]};
    border-radius: ${theme.borderRadius.sm};
    padding: ${theme.spacing(1.5)};
    margin-bottom: ${theme.spacing(1)};
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(1)};
  `}
`;

export const FormRow = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1)};
    width: 100%;
  `}
`;

export const Spacer = styled.div`
  flex: 1;
`;

export const FormHeader = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1)};
    width: 100%;
  `}
`;

export const FormField = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(1)};
  `}
`;

export const StyledTypography = styled(Typography)`
  white-space: nowrap;
`;
